import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import WeaMenu from '../../../../../pc4public/portal/wea-menu/';

import E8LeftMenuTop from './E8LeftMenuTop';
import E8LeftMenuBottom from './E8LeftMenuBottom';

@inject('portalThemeStore')
@observer
class E8LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
        this.onModeChange = this.onModeChange.bind(this);
    }

    componentDidUpdate() {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLoadLeftMenuCount();
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, leftMenuObj, leftMenuMode} = portalThemeStore;

        const {themeData = {}} = themeInfo;
        const {leftcolor} = themeData;

        const {leftMenu = [], leftMenuSelected = {}, leftMenuType} = leftMenuObj;
        let _leftMenu = toJS(leftMenu);
        let _leftMenuSelected = toJS(leftMenuSelected);
        let _selectedKey = _leftMenuSelected.id;

        return (
            <div className="e8aside-container" style={leftcolor ? {backgroundColor: leftcolor} : {}}>
                <div style={{width: '225px', height: '100%', display: leftMenuMode == 'inline' ? 'block' : 'none'}}>
                    <WeaMenu
                        mode={leftMenuMode}
                        needSwitch={false}
                        inlineWidth={225}
                        verticalWidth={0}
                        datas={(leftMenuType == 'email' && leftMenuMode == 'inline') ? _leftMenu.slice(2) : _leftMenu}
                        defaultSelectedKey={_selectedKey}
                        onSelect={this.onSelect}
                        onModeChange={this.onModeChange}
                        addonBefore={<E8LeftMenuTop emailMenu={leftMenuType == 'email' ? _leftMenu : []} onSelect={this.onSelect}/>}
                        addonBeforeHeight={leftMenuType == 'email' ? 115 : 80}
                        addonAfter={<E8LeftMenuBottom />}
                        addonAfterHeight={48}
                    />
                </div>
                <div className="e8left-lmb-shrink" style={{display: leftMenuMode == 'inline' ? 'block' : 'none'}} title={getLabel(20721, '收缩')} onClick={() => this.onModeChange('vertical')}></div>
                <div className="e8left-lmb-expand" style={{display: leftMenuMode == 'vertical' ? 'block' : 'none'}} title={getLabel(15315, '展开')} onClick={() => this.onModeChange('inline')}></div>
            </div>
        );
    }

    onSelect(key, item, type) {
        window.isPortalRender = true;

        // type=0表示正常点击菜单，type=1表示点击菜单后面的图标
        const {portalThemeStore} = this.props;
        if (type == 1 && item.id == '536-53606') {  // 邮件菜单，清空垃圾箱
            portalThemeStore.onClearEmail(item);
        } else {
            if (type == 1) {
                item.url = item.titleUrl;
            }

            if(item.url != '') {
                if(item.url== '/spa/document/static/index.html#/main/document/add'
                    || item.url== '/spa/document/static/index.html#/main/document/search'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/add'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/supervise'){
                    item.url = item.url.split("?")[0] + "?menuidforportal=" + "left_" + item.infoId;
                }

                if(item.url && item.url.indexOf('tabTitle') < 0){
                    if(item.url && item.url.indexOf('#') != '-1'){
                        let urlArr = item.url.split('#');
                        if(urlArr[1] && urlArr[1].indexOf('?')!= '-1'){
                            item.url = item.url + "&tabTitle=" + item.name;
                        }else {
                            item.url = item.url + "?tabTitle=" + item.name;
                        }
                    }else if(item.url && item.url.indexOf('?') != '-1'){
                        item.url = item.url + "&tabTitle=" + item.name;
                    }else {
                        item.url = item.url + "?tabTitle=" + item.name;
                    }
                }

            }

            portalThemeStore.onLeftMenuSelectedChange(item);
            portalThemeStore.onLoadMain(item);
        }
    }

    onModeChange(leftMenuMode) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLeftMenuModeChange(leftMenuMode);
    }
}

export default E8LeftMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenu.js